import {
    dashboardVerificationAccess,
    orderVerificationAccess,
    cartType,
    registerType,
} from "../SiteInfoVerificationOptions";
import {gateStatus} from "../GateStatus";
import {OrderOnUnAuthenticatedShoppingCart} from "../OrderOnUnAuthenticatedShoppingCart";
import {DeliveryOptions} from "../DeliveryOptions";
import {LoginOptions} from "../LoginOptions";
import {LoanOptions} from "../LoanOptions";
import {RescueOption} from "../RescueOption";
import {ChatAccessOptions} from "../ChatAccess";
import {ChatActivityOptions} from "../ChatActivity";
import {ProfileFillRequirementOptions} from "../profileFillRequirementOptions";
import {sendSmsAfterTwoStepLogin} from "../sendSmsAfterTwoStepLogin";
import {showUsersOrdersInMainDashboard} from "../showUsersOrdersInMainDashboard";
import {showPreFactorOptions} from "../showPreFactorOptions";

const pair = (off, on) => ({'0': off, '1': on});

export const siteInfoCategories = [
    {
        id: 'gateways',
        title: 'درگاه‌های پرداخت',
        description: 'اطلاعات اتصال هر درگاه، وضعیت آزمایشی و تنظیمات پرداخت',
        icon: 'credit-card',
    },
    {
        id: 'auth',
        title: 'تنظیمات ورود',
        description: 'ثبت‌نام، تایید هویت و الزام تکمیل پروفایل',
        icon: 'person-check',
    },
    {
        id: 'cart',
        title: 'تنظیمات سبد و سفارش',
        description: 'رفتار سبد خرید، وضعیت سفارش و اعلان‌ها',
        icon: 'cart',
    },
    {
        id: 'shipping',
        title: 'ارسال و آدرس',
        description: 'هزینه ارسال، شهر پیش‌فرض و کد پستی',
        icon: 'truck',
    },
    {
        id: 'identity',
        title: 'هویت سایت',
        description: 'نام، تماس، آدرس و فایل‌های ظاهری',
        icon: 'house',
    },
    {
        id: 'social',
        title: 'شبکه‌های اجتماعی',
        description: 'لینک شبکه‌هایی که در سایت نمایش داده می‌شوند',
        icon: 'share',
    },
    {
        id: 'sms',
        title: 'پیامک',
        description: 'پنل پیامک و قالب‌های ارسال',
        icon: 'chat-left-text',
    },
    {
        id: 'chat',
        title: 'چت',
        description: 'روشن یا خاموش بودن گفتگو و نوع دسترسی',
        icon: 'chat-dots',
    },
    {
        id: 'access',
        title: 'داشبورد و دسترسی',
        description: 'نمایش بخش‌ها و سطح دسترسی فروشگاه',
        icon: 'gear',
    },
    {
        id: 'integrations',
        title: 'سرویس‌ها و یکپارچه‌سازی',
        description: 'حسابداری، ترب، باسلام، آمار و سرویس‌های جانبی',
        icon: 'plug',
    },
    {
        id: 'other',
        title: 'سایر تنظیمات',
        description: 'مواردی که در دسته‌های بالا نیستند',
        icon: 'collection',
    },
];

const social = {
    category: 'social',
    hint: 'آدرس کامل صفحه، همراه با https.',
};

const secret = (label, hint) => ({
    key: label,
    label,
    hint,
    secret: true,
    ltr: true,
    required: true,
});

export const siteInfoMeta = {
    address: {category: 'identity', hint: 'آدرس پستی که در سایت نمایش داده می‌شود.'},
    postal_code: {category: 'identity', hint: 'کد پستی مربوط به آدرس فروشگاه.'},
    cell_phone: {category: 'identity', hint: 'شماره موبایل تماس فروشگاه.'},
    tel_phone: {category: 'identity', hint: 'شماره تلفن ثابت فروشگاه.'},
    email: {category: 'identity', hint: 'ایمیل رسمی سایت.'},
    fax: {category: 'identity', hint: 'شماره فکس.'},
    slogan: {category: 'identity', hint: 'شعار کوتاه سایت.'},
    site_name: {category: 'identity', hint: 'نامی که به‌عنوان عنوان سایت استفاده می‌شود.'},
    icon: {category: 'identity', hint: 'آیکون سایت. یک تصویر انتخاب کنید.'},
    loadingIcon: {category: 'identity', hint: 'تصویری که هنگام بارگذاری نمایش داده می‌شود.'},
    symbol: {category: 'identity', hint: 'نماد یا نشان اعتماد. این مورد را می‌توان چند بار ثبت کرد.'},
    copy_right: {category: 'identity', hint: 'متن حق نشر پایین سایت.'},
    tax: {category: 'identity', hint: 'درصد مالیات، بین ۰ تا ۱۰۰.'},
    host: {category: 'identity', hint: 'آدرس اصلی سایت، همراه با https.'},
    site_link: {category: 'identity', hint: 'لینک عمومی سایت. این مقدار از داخل فرم قابل ویرایش نیست.'},
    dashboard_link: {category: 'identity', hint: 'لینک داشبورد. این مقدار از داخل فرم قابل ویرایش نیست.'},
    default_language: {category: 'identity', hint: 'زبانی که به‌صورت پیش‌فرض برای محتوا استفاده می‌شود.'},
    default_product_image: {category: 'identity', hint: 'آدرس تصویر جایگزین برای محصولاتی که عکس ندارند.'},

    social_media_instagram: social,
    social_media_pinterest: social,
    social_media_twitter: social,
    social_media_linkedin: social,
    social_media_aparat: social,
    social_media_telegram: social,
    social_media_eitaa: social,
    social_media_whatsapp: {category: 'social', hint: 'شماره واتساپ با پیش‌شماره ۹۸، مثلاً 98912xxxxxxx.'},
    social_media_youtube: social,
    social_media_tamasha: social,
    social_media_namasha: social,
    social_media_facebook: social,

    gate_status: {
        category: 'gateways',
        hint: '۰ یعنی پرداخت واقعی. ۱ یعنی حالت آزمایشی؛ در این حالت برخی درگاه‌ها با اطلاعات تست کار می‌کنند.',
        options: gateStatus,
        positive: '0',
    },
    description_on_payment_page: {
        category: 'gateways',
        hint: 'متنی که در صفحه پرداخت به خریدار نشان داده می‌شود.',
    },
    loan_options: {
        category: 'gateways',
        hint: 'امکان پرداخت قسطی سفارش.',
        options: LoanOptions,
        toggle: true,
        positive: '1',
    },
    cash_on_delivery_categories: {
        category: 'gateways',
        hint: 'دسته‌ای که محصولاتش امکان پرداخت در محل دارند. برای هر دسته یک رکورد جدا ساخته می‌شود.',
    },
    cash_on_delivery_photo: {
        category: 'gateways',
        hint: 'اگر دریافت عکس روشن باشد، پرداخت در محل بدون تصویر ثبت نمی‌شود.',
        options: pair('بدون عکس', 'دریافت عکس'),
        toggle: true,
        positive: '1',
    },
    upload_image_on_factor: {
        category: 'gateways',
        hint: 'امکان آپلود تصویر کنار فاکتور.',
        options: pair('غیرفعال', 'فعال'),
        toggle: true,
        positive: '1',
    },
    zarinpal_fee_calculation: {
        category: 'gateways',
        hint: 'اگر محاسبه شود، کارمزد زرین‌پال قبل از انتقال به درگاه روی مبلغ اعمال می‌شود.',
        options: pair('محاسبه نشود', 'محاسبه شود'),
        toggle: true,
        positive: '1',
    },
    zarinpal_merchant_id: {
        category: 'gateways',
        hint: 'زرین‌پال فقط مرچند کد می‌خواهد. این مقدار در فیلد zarinpal_merchant_id ذخیره می‌شود.',
        fields: [
            secret('مرچند کد', 'Merchant ID را از پنل زرین‌پال کپی کنید.'),
        ],
    },
    payir_token: {
        category: 'gateways',
        hint: 'توکن درگاه پی. در حالت آزمایشی بک‌اند به‌جای این مقدار از test استفاده می‌کند.',
        fields: [
            secret('توکن پی', 'توکن پذیرنده را از پنل pay.ir وارد کنید.'),
        ],
    },
    idpay_token: {
        category: 'gateways',
        hint: 'توکن درگاه آیدی‌پی. در حالت آزمایشی یک توکن تست ثابت استفاده می‌شود.',
        fields: [
            secret('توکن آیدی‌پی', 'API Key را از پنل آیدی‌پی وارد کنید.'),
        ],
    },
    sama_merchant_gateway: {
        category: 'gateways',
        hint: 'توکن درگاه سما. کل مقدار همین یک قلم است.',
        fields: [
            secret('توکن سما', 'توکن پذیرنده سما را وارد کنید.'),
        ],
    },
    pasargad_token: {
        category: 'gateways',
        hint: 'پاسارگاد سه مقدار می‌خواهد و بک‌اند آن‌ها را با جداکننده ||| می‌خواند: کد پذیرنده، کد ترمینال، کلید خصوصی.',
        separator: '|||',
        fields: [
            {key: 'merchant', label: 'کد پذیرنده', hint: 'merchantCode پاسارگاد.', ltr: true, required: true},
            {key: 'terminal', label: 'کد ترمینال', hint: 'terminalCode پاسارگاد.', ltr: true, required: true},
            {key: 'private', label: 'کلید خصوصی', hint: 'کلید خصوصی درگاه. این متن می‌تواند چندخطی باشد.', secret: true, ltr: true, required: true, multiline: true},
        ],
    },
    mellat_gate_info: {
        category: 'gateways',
        hint: 'بانک ملت دقیقاً سه مقدار با ویرگول می‌خواهد: شماره ترمینال، نام کاربری، رمز عبور.',
        separator: ',',
        fields: [
            {key: 'terminal', label: 'شماره ترمینال', hint: 'terminalId بهجت ملت.', ltr: true, required: true},
            {key: 'username', label: 'نام کاربری', hint: 'userName درگاه ملت.', ltr: true, required: true},
            secret('رمز عبور', 'userPassword درگاه ملت.'),
        ],
    },
    meli_gate_info: {
        category: 'gateways',
        hint: 'بانک ملی سه مقدار با ویرگول می‌خواهد: شماره ترمینال، کلید رمزنگاری، شناسه پذیرنده.',
        separator: ',',
        fields: [
            {key: 'terminal', label: 'شماره ترمینال', hint: 'TerminalId سداد / ملی.', ltr: true, required: true},
            secret('کلید رمزنگاری', 'کلیدی که برای امضای تراکنش (SignData) استفاده می‌شود.'),
            {key: 'merchant', label: 'شناسه پذیرنده', hint: 'MerchantId بانک ملی.', ltr: true, required: true},
        ],
    },
    toman_gate_info: {
        category: 'gateways',
        hint: 'تومن دو مقدار با ویرگول می‌خواهد: شناسه فروشگاه و رمز احراز. بک‌اند این دو را به صورت shop:auth و سپس Base64 می‌فرستد.',
        separator: ',',
        fields: [
            {key: 'shop', label: 'شناسه فروشگاه', hint: 'shop_slug فروشگاه در تومن‌پی.', ltr: true, required: true},
            secret('رمز احراز', 'رمزی که کنار شناسه فروشگاه برای ساخت توکن استفاده می‌شود.'),
        ],
    },
    parsian_gate_info: {
        category: 'gateways',
        hint: 'پارسیان با پین پذیرنده کار می‌کند. بک‌اند همین مقدار را به‌عنوان PIN ارسال می‌کند.',
        fields: [
            secret('پین پذیرنده', 'PIN درگاه پارسیان.'),
        ],
    },
    sep_gate_info: {
        category: 'gateways',
        hint: 'سپ (سامان کیش) فقط شماره ترمینال می‌خواهد.',
        fields: [
            {key: 'terminal', label: 'شماره ترمینال', hint: 'TerminalId درگاه سامان کیش.', ltr: true, required: true},
        ],
    },
    sep_pos_gate_info: {
        category: 'gateways',
        hint: 'پوز سپ فقط شماره ترمینال می‌خواهد. اگر خالی باشد پرداخت این درگاه رد می‌شود.',
        fields: [
            {key: 'terminal', label: 'شماره ترمینال پوز', hint: 'TerminalId دستگاه پوز سپ.', ltr: true, required: true},
        ],
    },
    saderat_gate_info: {
        category: 'gateways',
        hint: 'صادرات (سپهر) فقط شماره ترمینال می‌خواهد.',
        fields: [
            {key: 'terminal', label: 'شماره ترمینال', hint: 'TerminalId درگاه صادرات.', ltr: true, required: true},
        ],
    },
    torobpay_gate_info: {
        category: 'gateways',
        hint: 'ترب‌پی با ویرگول ذخیره می‌شود: client_id، client_secret، username، password و در انتها درصد افزوده. اگر درصد نباشد، صفر است.',
        separator: ',',
        fields: [
            {key: 'client_id', label: 'شناسه کلاینت', hint: 'client_id ترب‌پی.', ltr: true, required: true},
            secret('رمز کلاینت', 'client_secret ترب‌پی.'),
            {key: 'username', label: 'نام کاربری', hint: 'username ترب‌پی.', ltr: true, required: true},
            secret('رمز عبور', 'password ترب‌پی.'),
            {key: 'surcharge_percent', label: 'درصد افزوده به فاکتور', hint: 'وقتی خریدار ترب‌پی را انتخاب کند، این درصد به کل مبلغ قابل پرداخت همان پرداخت اضافه می‌شود. ۰ یعنی بدون افزایش. اعشار را با نقطه بنویسید، مثلاً 10 یا 2.5.', ltr: true, required: true, percent: true, default: '0'},
        ],
    },
    digipay_gate_info: {
        category: 'gateways',
        hint: 'دیجی‌پی با ویرگول ذخیره می‌شود: client_id، client_secret، username، password و در انتها درصد افزوده. اگر درصد نباشد، صفر است.',
        separator: ',',
        fields: [
            {key: 'client_id', label: 'شناسه کلاینت', hint: 'client_id دیجی‌پی.', ltr: true, required: true},
            secret('رمز کلاینت', 'client_secret دیجی‌پی.'),
            {key: 'username', label: 'نام کاربری', hint: 'username دیجی‌پی.', ltr: true, required: true},
            secret('رمز عبور', 'password دیجی‌پی.'),
            {key: 'surcharge_percent', label: 'درصد افزوده به فاکتور', hint: 'وقتی خریدار دیجی‌پی را انتخاب کند، این درصد به کل مبلغ قابل پرداخت همان پرداخت اضافه می‌شود. ۰ یعنی بدون افزایش. اعشار را با نقطه بنویسید، مثلاً 10 یا 2.5.', ltr: true, required: true, percent: true, default: '0'},
        ],
    },
    computer_pos_ip_gate_info: {
        category: 'gateways',
        hint: 'آی‌پی کامپیوتری که نرم‌افزار پوز روی آن اجرا می‌شود.',
        fields: [
            {key: 'ip', label: 'آی‌پی کامپیوتر پوز', hint: 'مثلاً 192.168.1.20', ltr: true, required: true},
        ],
    },

    login_options: {
        category: 'auth',
        hint: 'روش ورود کاربر به سایت.',
        options: LoginOptions,
    },
    registerType: {
        category: 'auth',
        hint: 'لحظه تایید شماره موبایل در ثبت‌نام.',
        options: registerType,
    },
    dashboardVerificationAccess: {
        category: 'auth',
        hint: 'قبل از ورود به داشبورد چه تاییدی لازم است.',
        options: dashboardVerificationAccess,
    },
    orderVerificationAccess: {
        category: 'auth',
        hint: 'قبل از خرید چه تاییدی لازم است.',
        options: orderVerificationAccess,
    },
    profile_fill_requirement: {
        category: 'auth',
        hint: 'اگر الزامی باشد، کاربر تا تکمیل پروفایل نمی‌تواند ادامه دهد.',
        options: ProfileFillRequirementOptions,
        toggle: true,
        positive: '1',
    },
    profile_form: {category: 'auth', hint: 'شناسه فرمی که به‌عنوان پروفایل کاربر استفاده می‌شود.'},
    send_sms_after_two_step_login: {
        category: 'auth',
        hint: 'بعد از ثبت‌نام دو مرحله‌ای، رمز با پیامک ارسال شود یا نه.',
        options: sendSmsAfterTwoStepLogin,
        toggle: true,
        positive: '1',
    },
    api_config_for_code_meli_cellphone_authentication: {
        category: 'auth',
        hint: 'سرویس تطبیق کد ملی و موبایل دو مقدار با ویرگول می‌خواهد: شناسه کسب‌وکار و توکن کسب‌وکار uid.ir.',
        separator: ',',
        fields: [
            {key: 'business', label: 'شناسه کسب‌وکار', hint: 'businessId در requestContext.apiInfo.', ltr: true, required: true},
            secret('توکن کسب‌وکار', 'businessToken همان سرویس.'),
        ],
    },
    advance_description_on_profile: {category: 'auth', hint: 'متن یا تنظیمات بخش «موارد بیشتر» در پروفایل.'},

    cartType: {
        category: 'cart',
        hint: 'سبد قبل از ثبت‌نام ساخته شود یا فقط بعد از ورود.',
        options: cartType,
    },
    shopping_cart_single_quantity: {
        category: 'cart',
        hint: 'اگر فقط یک کالا باشد، سبد بیش از یک قلم را نمی‌پذیرد.',
        options: pair('چند کالا', 'فقط یک کالا'),
        toggle: true,
        positive: '1',
    },
    reserve_time_item_on_shopping_cart: {
        category: 'cart',
        hint: 'مدت رزرو موجودی داخل سبد، به دقیقه. حداقل ۱.',
    },
    order_on_unauthenticated_shopping_cart: {
        category: 'cart',
        hint: 'ثبت سفارش وقتی خریدار هنوز وارد حساب نشده است.',
        options: OrderOnUnAuthenticatedShoppingCart,
        toggle: true,
        positive: '1',
    },
    select_store_on_shopping_cart: {
        category: 'cart',
        hint: 'خریدار در سبد، فروشگاه محصول را انتخاب کند.',
        options: pair('غیرفعال', 'فعال'),
        toggle: true,
        positive: '1',
    },
    product_unit_warning: {category: 'cart', hint: 'آستانه تعداد موجودی که هشدار کم‌بودن کالا نشان داده شود.'},
    product_limit_reminder: {
        category: 'cart',
        hint: 'یادآوری وقتی موجودی محصول تمام می‌شود.',
        options: pair('غیرفعال', 'فعال'),
        toggle: true,
        positive: '1',
    },
    order_notification_for_expire: {
        category: 'cart',
        hint: 'پیام برای سبدی که نزدیک انقضا است.',
        options: pair('ارسال نشود', 'ارسال شود'),
        toggle: true,
        positive: '1',
    },
    order_after_payment_default_status: {
        category: 'cart',
        hint: 'وضعیتی که سفارش بلافاصله بعد از پرداخت موفق می‌گیرد.',
        options: {
            '0': 'منتظر پرداخت',
            '1': 'در حال پردازش',
            '2': 'تایید شده',
            '3': 'ارسال شده',
            '4': 'تحویل داده شده',
            '5': 'مرجوع شده',
            '6': 'لغو شده',
        },
    },
    show_pre_factor: {
        category: 'cart',
        hint: 'دکمه پیش‌فاکتور در سفارش‌ها.',
        options: showPreFactorOptions,
        toggle: true,
        positive: '1',
    },
    setNullPrice: {category: 'cart', hint: 'متن یا رفتاری که برای محصول بدون قیمت استفاده می‌شود.'},
    order_audio_notification: {category: 'cart', hint: 'فایل صوتی اعلان سفارش جدید. فرمت mp3، wav یا ogg و حداکثر ۱ مگابایت.'},

    deliver_price: {category: 'shipping', hint: 'هزینه ارسال ثابت، وقتی روش محاسبه روی هزینه ثابت باشد.'},
    deliver_free_if_price_bigger_than: {category: 'shipping', hint: 'اگر مبلغ سفارش از این عدد بیشتر شود، ارسال رایگان است.'},
    packaging_free_if_price_bigger_than: {category: 'shipping', hint: 'اگر مبلغ سفارش از این عدد بیشتر شود، بسته‌بندی رایگان است.'},
    delivery_option: {
        category: 'shipping',
        hint: 'روش محاسبه هزینه پست: مبلغ ثابت سایت، مبلغ خود محصول، جدول ارسال، یا نقشه.',
        options: DeliveryOptions,
    },
    delivery_option_with_table: {
        category: 'shipping',
        hint: 'محاسبه هزینه ارسال از جدول روش‌های ارسال.',
        options: pair('غیرفعال', 'از جدول ارسال'),
        toggle: true,
        positive: '1',
    },
    free_city_delivery: {category: 'shipping', hint: 'شهری که ارسال به آن رایگان است. هر شهر یک رکورد جدا دارد.'},
    default_province: {category: 'shipping', hint: 'استانی که در فرم‌ها از قبل انتخاب شده است.'},
    default_city: {category: 'shipping', hint: 'شهری که در فرم‌ها از قبل انتخاب شده است.'},
    require_postal_code_in_address: {
        category: 'shipping',
        hint: 'کد پستی در ثبت آدرس.',
        options: pair('اختیاری', 'الزامی'),
        toggle: true,
        positive: '1',
    },
    un_required_product_address: {category: 'shipping', hint: 'دسته‌ای که خرید محصولاتش بدون آدرس ممکن است.'},
    cities_version_loader: {
        category: 'shipping',
        hint: 'این مقدار کلید فعال/غیرفعال نیست. بک‌اند استان‌ها را با همین عدد به‌عنوان type فیلتر می‌کند.',
        options: pair('نسخه ۰', 'نسخه ۱'),
    },

    sms_token: {category: 'sms', hint: 'توکن دسترسی به پنل پیامک.'},
    sms_panel_name: {
        category: 'sms',
        hint: 'سرویس‌دهنده‌ای که ارسال پیامک با آن انجام می‌شود. اگر خالی باشد میکسیت‌وب در نظر گرفته می‌شود.',
        options: {
            mixitweb: 'میکسیت‌وب',
            melipayamak: 'ملی‌پیامک',
        },
    },
    sms_panel_settings: {category: 'sms', hint: 'آدرس API و قالب‌های ملی‌پیامک. هر قالب را جداگانه کامل کنید.'},
    project_id: {category: 'sms', hint: 'شناسه پروژه برای پیامک و اتصال پشتیبانی.'},

    chat_activity: {
        category: 'chat',
        hint: 'کل بخش گفتگو.',
        options: ChatActivityOptions,
        toggle: true,
        positive: '1',
    },
    chat_access: {
        category: 'chat',
        hint: 'چه کسی می‌تواند گفتگو را شروع کند.',
        options: ChatAccessOptions,
    },
    general_chat_group: {category: 'chat', hint: 'شناسه برچسب گروهی که گفتگوی عمومی به آن وصل است.'},

    show_users_orders_in_main_dashboard: {
        category: 'access',
        hint: 'بلوک سفارش‌های من در صفحه اول داشبورد.',
        options: showUsersOrdersInMainDashboard,
        toggle: true,
        positive: '1',
    },
    show_user_cellphone: {
        category: 'access',
        hint: 'نمایش شماره موبایل کاربران برای دیگران.',
        options: pair('مخفی', 'نمایش برای همه'),
        toggle: true,
        positive: '1',
    },
    cost_of_show_user_number: {category: 'access', hint: 'مبلغی که برای دیدن شماره تلفن کاربر دریافت می‌شود.'},
    store_access_to_content_management: {
        category: 'access',
        hint: 'فروشگاه به منوی مدیریت محتوا دسترسی داشته باشد.',
        options: pair('ندارد', 'دارد'),
        toggle: true,
        positive: '1',
    },
    restrict_store_access_to_dashboard: {
        category: 'access',
        hint: 'اگر دسترسی نداشته باشد، کاربر فروشگاه وارد داشبورد نمی‌شود.',
        options: pair('دسترسی دارد', 'دسترسی ندارد'),
        positive: '0',
    },
    dashboard_category_pagination: {
        category: 'access',
        hint: 'صفحه‌بندی لیست دسته‌بندی در داشبورد.',
        options: pair('غیرفعال', 'فعال'),
        toggle: true,
        positive: '1',
    },
    rescue_mode: {
        category: 'access',
        hint: 'حالت تعمیر؛ سایت برای بازدیدکننده عادی بسته می‌شود.',
        options: RescueOption,
        toggle: true,
        positive: '1',
    },
    cron_job_schedule: {category: 'access', hint: 'فاصله اجرای زمان‌بندی، به دقیقه. حداقل ۱.'},

    googleAnalytics: {category: 'integrations', hint: 'شناسه یا تگ گوگل آنالیتیکس.'},
    analytic_token: {category: 'integrations', hint: 'توکن یا لینک بخش آمار.'},
    basalam_token: {category: 'integrations', hint: 'توکن اتصال به باسلام.'},
    spot_player_api_token: {category: 'integrations', hint: 'کلید API اسپات‌پلیر.'},
    torob_category_items: {category: 'integrations', hint: 'دسته‌ای که محصولاتش برای ترب ارسال می‌شود.'},
    exchange_api: {category: 'integrations', hint: 'آدرس یا کلید API بخش نرخ ارز.'},
    holoo_status: {
        category: 'integrations',
        hint: 'اتصال به سیستم حسابداری.',
        options: pair('غیرفعال', 'فعال'),
        toggle: true,
        positive: '1',
    },
    hesabdari_type: {
        category: 'integrations',
        hint: 'برنامه‌ای که سفارش و محصول با آن همگام می‌شود. ۰ هلو است و ۱ آسان.',
        options: pair('هلو', 'آسان'),
    },
    odoo_sync_users_enabled: {
        category: 'integrations',
        hint: 'ارسال کاربران به اودو. فقط برای مدیر پنل دیده می‌شود.',
        options: pair('غیرفعال', 'فعال'),
        toggle: true,
        positive: '1',
    },
    odoo_settings: {category: 'integrations', hint: 'تنظیمات اتصال اودو. فقط برای مدیر پنل.'},
};

export function metaOf(name) {
    return siteInfoMeta[name] || {category: 'other', hint: ''};
}

export function categoryById(id) {
    return siteInfoCategories.find((item) => item.id === id) || siteInfoCategories[siteInfoCategories.length - 1];
}

export function credentialSchema(name) {
    const meta = siteInfoMeta[name];
    if (!meta || !meta.fields || !meta.fields.length) {
        return null;
    }
    return meta;
}

export function choiceOptionsOf(name) {
    const meta = siteInfoMeta[name];
    if (!meta || !meta.options) {
        return null;
    }
    return meta.options;
}

function lookupChoice(options, value) {
    if (options[value] != null) {
        return options[value];
    }
    const key = value == null ? '' : String(value);
    return options[key];
}

export function credentialSummary(value, meta) {
    if (value === '******') {
        return 'ثبت شده و محرمانه';
    }
    const raw = value == null ? '' : String(value);
    if (!meta.fields) {
        return raw;
    }
    if (!meta.separator) {
        return raw.trim() ? 'تکمیل شده' : 'خالی';
    }
    const chunks = raw ? raw.split(meta.separator) : [];
    const filled = meta.fields.filter((field, index) => String(chunks[index] || '').trim() !== '').length;
    return `${filled} از ${meta.fields.length} مورد تکمیل شده`;
}

export function smsPanelSummary(value) {
    let settings = value;
    if (typeof value === 'string') {
        try {
            settings = JSON.parse(value);
        } catch (e) {
            return value;
        }
    }
    if (!settings || typeof settings !== 'object') {
        return '—';
    }
    const templatesCount = settings.templates ? Object.keys(settings.templates).length : 0;
    return `API تنظیم شده | ${templatesCount} قالب`;
}

export function displaySiteInfoValue(item) {
    const name = item.name;
    const value = item.value;
    const meta = metaOf(name);

    if (name === 'icon' || name === 'loadingIcon') {
        return {type: 'image', text: '', src: value};
    }

    if (value && typeof value === 'object') {
        if (value.province && value.name) {
            return {type: 'text', text: `${value.province.name} - ${value.name}`};
        }
        if (value.name) {
            return {type: 'text', text: value.name};
        }
    }

    if (meta.options) {
        const label = lookupChoice(meta.options, value);
        if (label != null) {
            const current = value == null ? '' : String(value);
            return {
                type: 'choice',
                text: label,
                on: meta.positive ? current === String(meta.positive) : current === '1',
                toggle: !!meta.toggle || !!meta.positive,
            };
        }
    }

    if (meta.fields) {
        return {type: 'text', text: credentialSummary(value, meta)};
    }

    if (name === 'sms_panel_settings') {
        return {type: 'text', text: smsPanelSummary(value)};
    }

    if (value === '******') {
        return {type: 'text', text: 'محرمانه'};
    }

    if (value == null || value === '') {
        return {type: 'text', text: '—'};
    }

    const text = String(value);
    return {type: 'text', text: text.length > 110 ? `${text.slice(0, 110)}…` : text};
}

export function parseCredentialValue(raw, meta) {
    const parts = {};
    if (raw === '******') {
        meta.fields.forEach((field) => {
            parts[field.key] = '';
        });
        return {parts, locked: true};
    }

    const source = raw == null ? '' : String(raw);
    let chunks = [];
    if (!meta.separator) {
        chunks = [source];
    } else if (source) {
        chunks = source.split(meta.separator);
    }

    if (meta.separator && chunks.length > meta.fields.length) {
        const head = chunks.slice(0, meta.fields.length - 1);
        const tail = chunks.slice(meta.fields.length - 1).join(meta.separator);
        chunks = head.concat([tail]);
    }

    meta.fields.forEach((field, index) => {
        const chunk = chunks[index];
        if (chunk != null && String(chunk).trim() !== '') {
            parts[field.key] = chunk;
        } else if (field.default != null) {
            parts[field.key] = field.default;
        } else {
            parts[field.key] = chunk != null ? chunk : '';
        }
    });

    return {parts, locked: false};
}

export function joinCredentialValue(parts, meta) {
    const values = meta.fields.map((field) => String(parts[field.key] || '').trim());
    if (!meta.separator) {
        return values[0] || '';
    }
    return values.join(meta.separator);
}

export function validateCredentialValue(parts, meta) {
    const missing = meta.fields.filter((field) => field.required !== false && !String(parts[field.key] || '').trim());
    if (missing.length) {
        return `این موردها را کامل کنید: ${missing.map((field) => field.label).join('، ')}`;
    }
    if (meta.separator) {
        const broken = meta.fields.find((field) => String(parts[field.key] || '').includes(meta.separator));
        if (broken) {
            return `داخل «${broken.label}» نباید «${meta.separator}» باشد، چون بک‌اند با همین جداکننده مقدارها را می‌خواند.`;
        }
    }
    const invalidPercent = meta.fields.find((field) => {
        if (!field.percent) {
            return false;
        }
        const raw = String(parts[field.key] || '').trim();
        if (!/^\d+(\.\d+)?$/.test(raw)) {
            return true;
        }
        const number = Number(raw);
        return number < 0 || number > 100;
    });
    if (invalidPercent) {
        return 'درصد افزوده باید عددی بین ۰ تا ۱۰۰ باشد. برای اعشار از نقطه استفاده کنید، مثلاً 10 یا 2.5.';
    }
    return '';
}
